import Raven from 'raven-js';
import { InMemoryCache } from '../cache/InMemoryCache';
const fetchValidateUrl = (url, httpClient) => {
  return httpClient.post('property-validation/v1/property-validation/evaluate-proposed-rules', {
    data: {
      proposedRules: [{
        ruleType: 'URL',
        ruleArguments: []
      }],
      proposedValue: url
    }
  }).then(result => {
    if (result.length > 0) {
      return result[0];
    }
    return {
      isValid: true,
      error: null,
      message: null
    };
  }).catch(error => {
    Raven.captureException(error, {
      extra: {
        url
      }
    });
  });
};
const getCacheKey = url => url;
export const UrlValidationCache = new InMemoryCache('UrlValidationCache', fetchValidateUrl, getCacheKey);

// exported for unit test usage only
export const _resetCache = () => {
  UrlValidationCache.clear();
};